// extracted by mini-css-extract-plugin
export default {"iframe":"PointCloudViewer_iframe__nEVkc"};